module.exports = __webpack_public_path__ + "static/img/slide_1_en.d841c92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/live-hr-advice/slider/slide_1_en.png
// module id = malj
// module chunks = 0